import * as React from 'react';
import {
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
} from '@cian/ui-kit-design-tokens/icons';
import { EUndergroundType } from '../../../types/promosPage';

export const useUndergroundIcon = (undergroundType: EUndergroundType) => {
  return React.useMemo(() => {
    switch (undergroundType) {
      case EUndergroundType.Spb:
        return <IconMapMetroSpb16 color="current_color" />;
      case EUndergroundType.Ekb:
        return <IconMapMetroEkb16 color="current_color" />;
      case EUndergroundType.Kzn:
        return <IconMapMetroKzn16 color="current_color" />;
      case EUndergroundType.Nsk:
        return <IconMapMetroNovosib16 color="current_color" />;
      case EUndergroundType.Smr:
        return <IconMapMetroSam16 color="current_color" />;
      case EUndergroundType.Nn:
        return <IconMapMetroNN16 color="current_color" />;
      default:
        return <IconMapMetroMsk16 color="current_color" />;
    }
  }, [undergroundType]);
};
